/* eslint-disable react-hooks/exhaustive-deps */
import {Pagination} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";

import {queryLimit} from "../../constants";
import usePageNavigation from "../../hooks/usePageNavigation";

import {getAllMyServiceReceipts} from "../../services/requests/ApiRequests";
import {getQueryParams} from "../../utils";
import CashPicker from "./CashPicker";

const RECIEPT_TYPES = {
	1: "Input",
	2: "Output",
};

export default function ServiceReceipts(props) {
	let navigate = useNavigate();
	const {t} = useTranslation();
	const {pageNumber = "1"} = useParams();
	const [sortingDates, setSortingDates] = useState({
		postedFrom: null,
		postedTo: null,
	});
	const [journal, setJournal] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedCashierId, setSelectedCashierId] = useState("");
	const [selectedCashierName, setSelectedCashierName] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [pageCount, setPageCount] = useState(null);
	const [receiptsStart, setReceiptsStart] = useState(0);
	const [card, setCard] = useState(null);
	const [selectedCashRegisterId, setSelectedCashRegisterId] = useState(null);
	// const { organization, role } = props;
	const redirectLink = "acps/service-receipts";

	usePageNavigation(
		setCurrentPage,
		setReceiptsStart,
		pageNumber,
		queryLimit,
		pageCount,
		navigate,
		redirectLink
	);

	const handlePagination = (event, page) => {
		navigate(`/${redirectLink}/${page}`);
	};

	const getServiceReceipt = () => {
		if (!card) return;
		getAllMyServiceReceipts({
			...sortingDates,
			limit: queryLimit,
			start: receiptsStart,
			...card,
		}).then((data) => {
			setJournal(data.data.data);
			setPageCount(Math.ceil(data.data.count / queryLimit));
			setLoading(false);
		});
	};

	const onCashRegisterSubmit = (data) => {
		const {formData} = data;
		setCard(formData);
	};

	useEffect(() => {
		getServiceReceipt();
	}, [
		JSON.stringify(sortingDates),
		// selectedCashRegister,
		selectedCashierId,
		selectedCashierName,
		currentPage,
		card,
	]);

	return (
		<Box
			sx={{flexGrow: 1, marginTop: 3, marginLeft: 0, marginBottom: 10}}
		>
			<Grid container spacing={2} align="left">
				<Grid item xs={5}>
					<CashPicker
						onSubmit={onCashRegisterSubmit}
						setSelectedCashRegister={(cash) =>
							setSelectedCashRegisterId(cash?._id ?? null)
						}
					/>
				</Grid>
				<Grid item xs={6} sx={{marginTop: 6}} align="right">
					<Button
						variant="outlined"
						onClick={() => {
							navigate(`/acps/new-service-receipt${selectedCashRegisterId ? `?rid=${selectedCashRegisterId}` : ''}`);
						}}
					>
						{t("create_new_service_receipt")}
					</Button>
				</Grid>
			</Grid>

			<Grid container spacing={2} align="left" sx={{marginTop: 3}}>
				<Grid item xs={11}>
					<TableContainer component={Paper}>
						<Table sx={{minWidth: 650}} aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell>{t("id")}</TableCell>
									<TableCell align="right">
										{t("operation_type")}
									</TableCell>
									<TableCell align="right">
										{t("date_time")}
									</TableCell>
									<TableCell align="right">
										{t("sum")}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{journal.map((receipt) => {
									const isInput =
										receipt.soap_data.data.type === 1;
									return (
										<TableRow
											hover
											key={receipt.soap_data.id}
											sx={{
												"&:last-child td, &:last-child th":
													{border: 0},
											}}
											onClick={() => {
												const rid =
													selectedCashRegisterId ||
													receipt.cash_register_id;
												const qs = rid
													? `rid=${rid}&${getQueryParams(
														card
													)}`
													: getQueryParams(card);
												navigate(
													`/acps/service-receipt/${receipt._id}?${qs}`
												);
											}}
										>
											<TableCell align="left">
												{receipt.soap_data.id}
											</TableCell>
											<TableCell align="right">
												{isInput
													? t("input_cash")
													: t("output_cash")}
											</TableCell>
											<TableCell align="right">
												{receipt.soap_data.datetime}
											</TableCell>
											<TableCell align="right">
												{receipt.soap_data.data.total}
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				{pageCount > 1 && (
					<Grid item xs={11} align="center">
						<Pagination
							sx={{
								mt: 5,
								justifyContent: "center",
								display: "flex",
							}}
							count={pageCount}
							variant="outlined"
							shape="rounded"
							page={+currentPage}
							onChange={handlePagination}
						/>
					</Grid>
				)}
			</Grid>
		</Box>
	);
}
